export const ActivityIconMapping = {
    "share-create": "add-new-folder",
    "path-add": "add-circle-outline",
    "path-add-share": "add-circle-outline",
    "path-move": "move-file-folder",
    "path-move-share": "move-file-folder",
    "path-deleted": "delete",
    "path-deleted-share": "delete",
    "path-rename": "rename",
    "path-edited": "edit",
    "path-rename-share": "rename",
    "path-edited-share": "edit",
    "path-restore": "restore",
    "path-restore-share": "restore",
    "path-purge": "purge",
    "path-purge-share": "purge",
    "rewind-dir": "restore",
    "migrate-done": "folder-sync",
    "migrate-done__1": "folder-sync",
    "migrate-done__2": "folder-sync",
    "migrate-done__3": "folder-sync",
    "migrate-done__4": "folder-sync",
    "migrate-done__5": "folder-sync",
    "migrate-done__6": "folder-sync",
    "migrate-started": "folder-sync",
    "link-create": "link",
    "link-delete": "delete",
    "link-send-url": "send",
    "link-download": "download",
    "link-upload": "upload",
    "link-comment-create": "comment",
    "link-comment-update": "comment",
    "link-comment-delete": "comment",
    "share-promoted-as-owner": "user-circle",
    "share-ownership-transfered": "user-circle",
    "share-invite-owner": "user-add",
    "share-accept-user": "user-add",
    "share-accept-owner": "user-add",
    "share-remove-owner": "user-remove",
    "share-leave-owner": "user-remove",
    "share-invite-user": "user-add",
    "share-remove-user": "user-remove",
    "share-leave-user": "user-remove",
    "account-migrated": "team",
    "provision-user": "user-add",
    "provision-device": "computer-and-phone",
    "upgrade-device": "computer-and-phone",
    "email-notification-changed": "email",
    "auth-login-success": "sign-in",
    "auth-login-fail": "sign-in",
    "auth-login-2fa-prompted": "shield-2sv",
    "auth-login-2fa-incorrect": "shield-2sv",
    "auth-user-backup-code-create": "shield-2sv",
    "auth-user-backup-code-consume": "shield-2sv",
    "password-reset-changed": "sign-in",
    "password-reset-request": "sign-in",
    "password-update": "sign-in",
    "password-update-multiuser-parent": "sign-in",
    "password-update-multiuser-child": "sign-in",
    "username-changed": "sign-in",
    "app-integration-add": "integrations",
    "app-integration-remove": "integrations",
}

export interface EventOptions {
    _id?: string;
    offset: number;
    sliceLimit?: number;
    sliceOffset?: number;
    shareId?: number;
    date?: number;
    limit?: number;
    eventTypes?: Array<number>;
    sort?: {
        [Key: string]: -1 | 1;
    }
}

export interface EventResult {
    success: number;
    new_count: number;
    events: EventItem[];
    shares: Shares[];
    error_code: number;
}
export interface EventItem {
    _id: string;
    user_id: number;
    servtime: number;
    hist_id: number;
    share_id: number;
    items: Items;
    eventtype: string;
}
export interface Items {
    event_display_name?: string | null;
    event_user_id?: number | null;
    pathitems?: (EventPathitems)[] | null;
    filename?: string;
    linkname?: string;
    pathitems_count?: number | null;
    invault?: number;
    platform?: string | null;
    browser?: string | null;
    ipaddr?: string | null;
    device_type_id?: number | null;
    device_id?: number | null;
    device_name?: string | null;
    sync_id?: number | null;
    enc_meta_name?: string | null;
    label?: string | null;
    sync_pid?: number | null;
    permission?: (string)[] | null;
    root_sync_id?: number;
    name?: string;
    author?: string;
    syncPid?: number;
    hasfailedfiles?: number;
    email_type?: string;
    invited_by_email?: string;
    new_email?: string;
    old_email?: string;
    user_email?: string;
    recipientEmail?: string;
    actor_display_name?: string;
    old_owner_email?: string;
    new_owner_email?: string;
    invitee_email?: string;
    parent_email?: string;
    child_email?: string;
    inviter_display_name?: string;
    invitee_display_name?: string;
    app_name?: string;
    new_version?: string;
    devicetype_name?: string;
    device_type_name?: string;
    inviter_user_id?: number;
    jobtype?: string;
    jobstatus?: number;
    purge?: number;
    servtime?: number;
    enabled?: number;
    extra?: {total_bytes?: number};
    action?: string;
}
export interface EventPathitems {
    name?: string;
    hist_id: number;
    invault: number;
    active: number;
    sync_id: number;
    sync_pid: number;
    servtime: number;
    share_id: number;
    blob_id: number;
    size: number;
    file_size?: number;
    event_device_id: number;
    enc_meta_name: string;
    kids?: any[] | null;
    synctype?: (string)[] | null;
}
export interface Shares {
    share_id: number;
    enc_meta_name: string;
    label: string;
}

export interface ActivityFilter {
    activity: String,
    folder: String,
    daterange: {date: Date, endDate: Date}
}

export const EVENT_LIMIT = 50;

export interface EventShareResponse {
    success: number;
    shares: EventShare[];
}

export interface EventShare {
    share_id: number;
    enc_meta_name: string;
    label: string;
    display_name?: string;
    name?: string;
}